import Vue from 'vue'
import Router from 'vue-router'
import home from '@/views/home'
import notice from '@/views/notice'
//import entry from '@/views/entry'
import reword from '@/views/reword'
import show from '@/views/show'
import show2 from '@/views/show2'
import aboutUs from '@/views/aboutUs'
import commit from '@/views/commit'
import commitdetail from '@/views/commitdetail'
import review from '@/views/review'
import progress from '@/views/progress'
import person from '@/views/person'
import information from '@/views/information'
import manage from '@/views/manage'
import contact from '@/views/contact'
import submission from '@/views/submission'
import message from '@/views/message'
import privateLetter from '@/views/privateLetter'
import edit from '@/views/edit'
import leaveMessage from '@/views/leaveMessage'
import sendLetter from '@/views/sendLetter'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
		{
	   	path:'/commit',
	   	name:'commit',
	   	component: commit
	  },
	  {
	   	path:'/commitdetail',
	   	name:'commitdetail',
	   	component: commitdetail
	  },
	  {
	   	path:'/review',
	   	name:'review',
	   	component:review
	  },
	  {
	   	path:'/progress',
	   	name:'/progress',
	   	component:progress
	  },
    {
      path: '/reword',
      name: 'reword',
      component: reword
    },
    {
      path: '/show',
      name: 'show',
      component: show
    },
    {
      path: '/show2',
      name: 'show2',
      component: show2
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: aboutUs
    },
    {
      path: '/person',
      name: 'person',
      component: person,
      children:[
      	{
		      path: '/person/information',
		      name: 'information',
		      component: information
		    },
		    {
		      path: '/person/manage',
		      name: 'manage',
		      component: manage
		    },
		    {
		      path: '/person/contact',
		      name: 'contact',
		      component: contact
		    },
		    {
		      path: '/person/submission',
		      name: 'submission',
		      component: submission
		    },
		    {
		    	path:'/person/edit',
		    	name:'edit',
		    	component:edit
		    },
		    {
		    	path:'/person/leaveMessage',
		    	name:'leaveMessage',
		    	component:leaveMessage
		    }
      ]
    },
    {
    	path:'/message',
    	name:'message',
    	component:message,
    	children:[
    		{
		    	path:'/message/privateLetter',
		    	name:'privateLetter',
		    	component:privateLetter
		    },
		    {
		      path: '/message/notice',
		      name: 'notice',
		      component: notice
		    },
		    {
		      path: '/message/sendLetter',
		      name: 'sendLetter',
		      component: sendLetter
		    }
    	]
    },
    
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js